declare let __webpack_public_path__: string;
if (window.location.pathname.startsWith("/cms-preview/")) __webpack_public_path__ = "/cms-preview/";
export {};
